<template>
    <!-- Note: 这里必须保证 只有 add-container 一个节点 -->
    <add-container
        ref="container"
        :init-item="()=>initBaozhiqi(flowSpecByCategoryInfo)"
        :item-list="data"
        :all-city-list="allCityList"
        :public-city-ids="publicCityIds"
        :is-required="isRequired"
        :disabled="disabled"
        :pre-sku-id="preSkuId"
        :can-delete-condition="(item) => canDeleteWithRuleCheck(item)"
        :guarantee-period-rule-map="guaranteePeriodRuleMap"
        title="保质期"
    >
        <div
            slot-scope="scope"
            :class="{'existed-ids-disabled': scope.item.existedIds && scope.item.existedIds.length > 0}"
        >
            <xx-form-item
                class="is-required"
                label="保质期"
                :prop="`guaranteePeriod.${scope.$index}`"
                :rules="rules.guaranteePeriod"
            >
                <el-input-number
                    v-if="scope.item.guaranteePeriodType !== 0"
                    v-model="scope.item.guaranteePeriod"
                    :controls="false"
                    placeholder="请输入"
                    class="input-with-select"
                    :disabled="disabled || (!!preSkuId && isPdArchiveCity(scope.item))"
                    :style="{'width': '130px !important'}"
                    @change="(value) => {onTypeChange(value,scope.item.guaranteePeriodType, scope.item)}"
                />
                <xx-select
                    v-model="scope.item.guaranteePeriodType"
                    :clearable="false"
                    style="width: 130px !important"
                    dic-code="special:product:newsell_guaranteePeriodType"
                    :disabled="disabled || (!!preSkuId && isPdArchiveCity(scope.item))"
                    @change="(type) => {onTypeChange(scope.item.guaranteePeriod, type, scope.item)}"
                />
                <example-pic type="guaranteePeriod" />
            </xx-form-item>
            <xx-form-item
                v-if="isShowReason(scope.item)"
                class="is-required"
                label="修改原因"
                :prop="`guaranteePeriod.${scope.$index}`"
                :rules="rules.guaranteePeriodChangeReason"
            >
                <mc-select
                    v-model="scope.item.guaranteePeriodChangeReason"
                    :source="{dictCode:'special:product:guarantee_period_change_reason'}"
                    :scroll-step="{size: 20}"
                    :disabled="disabled"
                />
            </xx-form-item>
            <div
                v-if="getAdvicePeriodForCity(scope.item)"
                class="description"
            >
                建议填写保质期  <span class="prompt-day">{{ getAdvicePeriodForCity(scope.item) }}</span>,
                如不符合实际情况，请按实际情况填写，例：商品包装上带有保质期的，以包装上保质期为准
            </div>
        </div>
    </add-container>
</template>

<script>
import { cloneDeep } from '@lsfe/tools';
import AddContainer from './addContainer';
import { initBaozhiqi, guaranteePeriodTypeEnum, guaranteePeriodTypeMap } from './config';
import autoFillCityId from './mixins/autoFillCityId';
import ExamplePic from '../components/ExamplePicDialog';
import { getBaseModel } from '../baseModel';

// 【新增】时间单位映射常量
const PERIOD_TIME_MAP = {
    3: '天',
    2: '月',
    1: '年',
    0: '无限制',
};

export default {
    components: {
        AddContainer,
        ExamplePic,
    },
    mixins: [autoFillCityId],
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        allCityList: {
            type: Array,
            default: () => [],
        },
        publicCityIds: {
            type: Array,
            default: () => [],
        },
        // 是否有默认保质期
        guaranteePeriodAdviceNumberDay: {
            type: [String, Number],
            default: '',
        },

        // 是否至少保留一个item，"是"则第一个item没有delete按钮
        isRequired: {
            type: Boolean,
            default: true,
        },
        canDeleteCondition: {
            type: Function,
            default: () => true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        flowSpecByCategoryInfo: {
            type: Object,
            default: () => ({}),
        },
        preSkuId: {
            type: String,
            default: '',
        },
        // 是否在灰度内
        isInGray: {
            type: Boolean,
            default: false,
        },
        // 按城市+业态分组的保质期规则映射
        guaranteePeriodRuleMap: {
            type: Object,
            default: () => ({}),
        },
        // 保质期规则列表（用于分组）
        guaranteePeriodRuleInfoList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        const isIntegerAndInRange = (value, min, max) => {
            const isInteger = Number.isInteger(value);
            const inRange = value > min && value < max;
            return isInteger && inRange;
        };
        const guaranteePeriodValid = (rule, value, callback) => {
            if (value.guaranteePeriodType !== 0 && !value.guaranteePeriodType) {
                callback('保质期单位必选');
            } else if (value.guaranteePeriodType === 0) {
                callback(); // 无保质期限制，不做校验
            } else if (!isIntegerAndInRange(value.guaranteePeriod, 0, 999999)) {
                callback(new Error('保质期大于0并且小于999999的整数'));
            } else {
                callback();
            }
        };
        const guaranteePeriodReasonValid = (rule, value, callback) => {
            if (value.guaranteePeriodChangeReason) {
                callback();
            } else {
                callback('保质期原因必填');
            }
        };
        return {
            initBaozhiqi,
            rules: {
                guaranteePeriod: [
                    {
                        validator: guaranteePeriodValid,
                    },
                ],
                guaranteePeriodChangeReason: [{ validator: guaranteePeriodReasonValid }],
            },
        };
    },
    computed: {
        // 是否展示保质期原因（当用户填写的保质期不等于建议保质期）
        isShowReason() {
            return (row) => {
                const guaranteePeriodType = guaranteePeriodTypeEnum.find((item) => row.guaranteePeriodType === item.value);
                if (!guaranteePeriodType) return false;

                // 用户输入的保质期文案
                // 【修复】当为无期限时，直接使用"无限制"，不要拼接空字符串
                const userEnteredPeriod = row.guaranteePeriodType === 0 ? guaranteePeriodType.label : (row.guaranteePeriod + guaranteePeriodType.label);

                // 【新增】如果在灰度内，从规则映射中获取对应城市的默认保质期
                if (this.isInGray && this.guaranteePeriodRuleMap && Object.keys(this.guaranteePeriodRuleMap).length > 0) {
                    const cityId = row.cityIds?.[0];
                    if (cityId) {
                        const rule = this.guaranteePeriodRuleMap[cityId];
                        if (rule) {
                            const { guaranteePeriod, guaranteePeriodType: ruleType } = rule;
                            const ruleTypeEnum = guaranteePeriodTypeEnum.find((item) => item.value === ruleType);
                            if (ruleTypeEnum) {
                                // 【修复】使用 cptTime 方法转换时间单位，无期限直接返回标签
                                let defaultPeriod = '';
                                if (ruleType === 0) {
                                    defaultPeriod = ruleTypeEnum.label;
                                } else {
                                    const day = this.cptTime(ruleType) || '';
                                    defaultPeriod = guaranteePeriod + day;
                                }
                                // 比较用户输入的保质期与默认保质期是否一致
                                return userEnteredPeriod !== defaultPeriod;
                            }
                        }
                    }
                }

                // 否则使用全局的建议保质期
                return this.guaranteePeriodAdviceNumberDay && userEnteredPeriod !== this.guaranteePeriodAdviceNumberDay;
            };
        },
        // pb 档案城市列表
        pdArchiveCityList() {
            if (!this.preSkuId) {
                return [];
            }
            const baseModel = getBaseModel();
            if (!baseModel) {
                return [];
            }
            // 如果没有 cityPreSkuBriefInfoList，从 citySkuManageSection 获取
            const citySkuManageSection = baseModel.models?.citySkuManageSection || baseModel.data?.citySkuManageSection;
            const citySkuManageInfo = citySkuManageSection?.citySkuManageInfo || [];
            return citySkuManageInfo.map((item) => item.cityId);
        },
    },
    created() {
    },
    methods: {
        // 判断 item 对应的城市是否是 pb 档案带过来的
        isPdArchiveCity(item) {
            if (!this.preSkuId || !this.pdArchiveCityList.length) {
                return false;
            }
            // 检查 item 的 cityIdAndTypes 中是否有 pb 档案的城市
            const cityIdAndTypes = item.cityIdAndTypes || [];
            if (!cityIdAndTypes || cityIdAndTypes.length === 0) {
                return false;
            }
            // 如果 item 的所有城市都是 pb 档案城市，则返回 true
            return cityIdAndTypes.every((cityInfo) => {
                const cityId = cityInfo.cityId;
                return this.pdArchiveCityList.includes(cityId);
            });
        },
        getData() {
            return this.$refs.container.getData();
        },
        /**
         * 检查是否可以删除保质期项目
         * 如果有保质期分组规则，不允许删除
         */
        canDeleteWithRuleCheck(item) {
            // 如果有保质期规则信息列表，则不允许删除
            if (this.guaranteePeriodRuleInfoList && this.guaranteePeriodRuleInfoList.length > 0) {
                return false;
            }
            // 否则使用原来的删除条件
            return this.canDeleteCondition(item);
        },
        onTypeChange(value, type, item) {
            if (type === guaranteePeriodTypeMap.indefinite) {
                item.guaranteePeriod = '';
            }
            this.handleReason(item);
        },
        // 清空保质期原因
        handleReason(item) {
            if (!this.isShowReason) {
                item.guaranteePeriodChangeReason = '';
            }
        },
        // 根据城市+业态获取对应的建议保质期
        getAdvicePeriodForCity(item) {
            // 如果在灰度内，从规则映射中获取对应城市的建议保质期
            if (this.isInGray && this.guaranteePeriodRuleMap && Object.keys(this.guaranteePeriodRuleMap).length > 0) {
                // 【修改】优先使用已选城市的保质期规则
                if (item.cityIds && item.cityIds.length > 0) {
                    // 获取已选城市中有默认保质期的城市
                    const citiesWithRule = item.cityIds.filter((cityId) => this.guaranteePeriodRuleMap[cityId]);
                    if (citiesWithRule.length > 0) {
                        const rule = this.guaranteePeriodRuleMap[citiesWithRule[0]];
                        if (rule) {
                            const { guaranteePeriod, guaranteePeriodType } = rule;
                            const num = guaranteePeriodType ? guaranteePeriod : '';
                            const day = this.cptTime(guaranteePeriodType) || '';
                            const result = num + day;
                            return result;
                        }
                    }
                }
                // 【修改】当已选城市为空时，不展示默认保质期
                // 只有当分组中有选中的城市时，才展示默认保质期
            }
            return this.guaranteePeriodAdviceNumberDay;
        },
        // 【优化】时间单位转换 - 使用常量映射
        cptTime(val) {
            return PERIOD_TIME_MAP[val] || null;
        },
        /**
         * 【优化】判断城市是否有默认保质期（包括无期限）
         */
        hasDefaultGuaranteePeriod(rule) {
            // 无期限 (guaranteePeriodType === 0) 或者 有具体的保质期值 (guaranteePeriod && guaranteePeriodType)
            return rule.guaranteePeriodType === 0 || (rule.guaranteePeriod && rule.guaranteePeriodType && rule.guaranteePeriod !== 0 && rule.guaranteePeriodType !== 0);
        },
        /**
         * 【优化】分离城市分类逻辑
         * 分为两类：
         * 1. 有默认保质期的城市（包括无期限）
         * 2. 无默认保质期的城市
         */
        classifyCitiesByDefault(guaranteePeriodRuleInfoList) {
            const citiesWithDefault = [];
            const citiesWithoutDefault = [];

            guaranteePeriodRuleInfoList.forEach((rule) => {
                if (this.hasDefaultGuaranteePeriod(rule)) {
                    citiesWithDefault.push(rule);
                } else {
                    citiesWithoutDefault.push(rule);
                }
            });

            return { citiesWithDefault, citiesWithoutDefault };
        },
        /**
         * 【优化】处理接口未返回的城市
         */
        handleNotReturnedCities(allSelectedCityIds, guaranteePeriodRuleInfoList) {
            const returnedCityIdSet = new Set(guaranteePeriodRuleInfoList.map((rule) => rule.manageCityId));
            const notReturnedCityIds = allSelectedCityIds.filter((cityId) => !returnedCityIdSet.has(cityId));

            return notReturnedCityIds.map((cityId) => {
                const cityName = (this.allCityList && Array.isArray(this.allCityList))
                    ? this.allCityList.find((city) => city.value === cityId)?.label || ''
                    : '';
                return {
                    manageCityId: cityId,
                    manageCityName: cityName,
                    guaranteePeriod: null,
                    guaranteePeriodType: null,
                };
            });
        },
        /**
         * 【优化】构建现有数据的城市映射
         */
        buildExistingCityMap(existingData) {
            const existingCityMap = {};
            existingData.forEach((item) => {
                (item.cityIds || []).forEach((cityId) => {
                    existingCityMap[cityId] = {
                        guaranteePeriod: item.guaranteePeriod,
                        guaranteePeriodType: item.guaranteePeriodType,
                        guaranteePeriodChangeReason: item.guaranteePeriodChangeReason,
                    };
                });
            });
            return existingCityMap;
        },
        /**
         * 【优化】分组有默认保质期的城市
         */
        groupCitiesWithDefault(citiesWithDefault, existingCityMap) {
            const groupMapWithDefault = {};
            citiesWithDefault.forEach((rule) => {
                const existingPeriodData = existingCityMap[rule.manageCityId];
                let guaranteePeriod = existingPeriodData?.guaranteePeriod || rule.guaranteePeriod;
                const guaranteePeriodType = existingPeriodData?.guaranteePeriodType || rule.guaranteePeriodType;

                // 【修复】无限制情况下，保质期应该为空字符串
                if (guaranteePeriodType === 0) {
                    guaranteePeriod = '';
                }

                const groupKey = `${guaranteePeriod}_${guaranteePeriodType}`;
                if (!groupMapWithDefault[groupKey]) {
                    groupMapWithDefault[groupKey] = {
                        guaranteePeriod,
                        guaranteePeriodType,
                        guaranteePeriodChangeReason: existingPeriodData?.guaranteePeriodChangeReason || '',
                        cityIds: [],
                    };
                }
                groupMapWithDefault[groupKey].cityIds.push(rule.manageCityId);
            });
            return groupMapWithDefault;
        },
        /**
         * 【优化】分组无默认保质期的城市
         */
        groupCitiesWithoutDefault(citiesWithoutDefault, existingCityMap) {
            const groupMapWithoutDefault = {};
            citiesWithoutDefault.forEach((rule) => {
                const existingPeriodData = existingCityMap[rule.manageCityId];
                const guaranteePeriod = existingPeriodData?.guaranteePeriod || rule.guaranteePeriod || 'empty';
                const guaranteePeriodType = existingPeriodData?.guaranteePeriodType || rule.guaranteePeriodType || 'empty';
                const groupKey = `${guaranteePeriod}_${guaranteePeriodType}`;

                if (!groupMapWithoutDefault[groupKey]) {
                    groupMapWithoutDefault[groupKey] = {
                        guaranteePeriod: existingPeriodData?.guaranteePeriod || rule.guaranteePeriod,
                        guaranteePeriodType: existingPeriodData?.guaranteePeriodType || rule.guaranteePeriodType,
                        guaranteePeriodChangeReason: existingPeriodData?.guaranteePeriodChangeReason || '',
                        cityIds: [],
                    };
                }
                groupMapWithoutDefault[groupKey].cityIds.push(rule.manageCityId);
            });
            return groupMapWithoutDefault;
        },
        /**
         * 【优化】转换分组结果为最终格式
         */
        convertGroupsToFinalFormat(groupMap) {
            return Object.values(groupMap).map((group) => ({
                guaranteePeriod: group.guaranteePeriod !== undefined && group.guaranteePeriod !== null ? group.guaranteePeriod : '',
                guaranteePeriodType: group.guaranteePeriodType !== undefined && group.guaranteePeriodType !== null ? group.guaranteePeriodType : '',
                guaranteePeriodChangeReason: group.guaranteePeriodChangeReason || '',
                cityIds: group.cityIds,
                existedIds: [],
            }));
        },
        /**
         * 【新增】已有保质期数据时，根据分组规则重新组织，但保留输入框的值
         * 这个方法用于命中灰度且已有保质期数据的情况
         */
        autoGroupGuaranteePeriodByRuleWithExistingData(guaranteePeriodRuleInfoList) {
            const allSelectedCityIds = this.publicCityIds || [];
            const existingData = cloneDeep(this.data);

            // 构建现有数据的城市到保质期的映射
            const existingCityMap = this.buildExistingCityMap(existingData);

            // 分类城市
            const { citiesWithDefault, citiesWithoutDefault } = this.classifyCitiesByDefault(guaranteePeriodRuleInfoList);

            // 处理接口未返回的城市
            const notReturnedCities = this.handleNotReturnedCities(allSelectedCityIds, guaranteePeriodRuleInfoList);
            citiesWithoutDefault.push(...notReturnedCities);

            const autoGroups = [];

            // 1. 有默认保质期的城市（包括无期限）：按保质期值分组
            const groupMapWithDefault = this.groupCitiesWithDefault(citiesWithDefault, existingCityMap);
            autoGroups.push(...this.convertGroupsToFinalFormat(groupMapWithDefault));

            // 2. 没有默认保质期的城市：按输入框保质期值分组
            if (citiesWithoutDefault.length > 0) {
                const groupMapWithoutDefault = this.groupCitiesWithoutDefault(citiesWithoutDefault, existingCityMap);
                autoGroups.push(...this.convertGroupsToFinalFormat(groupMapWithoutDefault));
            }

            // 赋值给保质期
            this.$emit('update-guarantee-period', autoGroups);
        },

        /**
         * 【新增】统一入口方法，根据是否有现有数据决定调用哪个分组方法
         * 这个方法由父组件调用
         */
        autoGroupGuaranteePeriodByRuleList(guaranteePeriodRuleInfoList) {
            // 【修复】判断是否有现有保质期数据
            const hasExistingData = this.data && this.data.length > 0;

            if (hasExistingData) {
                // 【修复】已有保质期数据时，需要根据分组规则重新组织，但保留输入框的值
                this.autoGroupGuaranteePeriodByRuleWithExistingData(guaranteePeriodRuleInfoList);
            } else {
                // 【修复】自动分组逻辑：根据保质期值自动将城市分组
                // 分组规则：没有默认保质期且输入框保质期一致的城市才为一组
                this.autoGroupGuaranteePeriodByRule(guaranteePeriodRuleInfoList);
            }
        },

        /**
         * 根据保质期规则自动分组
         * 分组规则：
         * - 有默认保质期的城市（包括无期限）+ 保质期值一致 = 可以为一组
         * - 没有默认保质期的城市 + 输入框保质期一致 = 可以为一组
         * - 有默认保质期和没有默认保质期的城市 = 不能为一组（即使保质期一致）
         */
        autoGroupGuaranteePeriodByRule(guaranteePeriodRuleInfoList) {
            const allSelectedCityIds = this.publicCityIds || [];

            // 分类城市
            const { citiesWithDefault, citiesWithoutDefault } = this.classifyCitiesByDefault(guaranteePeriodRuleInfoList);

            // 处理接口未返回的城市
            const notReturnedCities = this.handleNotReturnedCities(allSelectedCityIds, guaranteePeriodRuleInfoList);
            citiesWithoutDefault.push(...notReturnedCities);

            const autoGroups = [];

            // 1. 有默认保质期的城市（包括无期限）：按保质期值分组
            const groupMapWithDefault = {};
            citiesWithDefault.forEach((rule) => {
                let guaranteePeriod = rule.guaranteePeriod;
                const guaranteePeriodType = rule.guaranteePeriodType;

                // 【修复】无限制情况下，保质期应该为空字符串
                if (guaranteePeriodType === 0) {
                    guaranteePeriod = '';
                }

                const groupKey = `${guaranteePeriod}_${guaranteePeriodType}`;
                if (!groupMapWithDefault[groupKey]) {
                    groupMapWithDefault[groupKey] = {
                        guaranteePeriod,
                        guaranteePeriodType,
                        cityIds: [],
                    };
                }
                groupMapWithDefault[groupKey].cityIds.push(rule.manageCityId);
            });

            autoGroups.push(...this.convertGroupsToFinalFormat(groupMapWithDefault));

            // 2. 没有默认保质期的城市：按输入框保质期值分组
            if (citiesWithoutDefault.length > 0) {
                const groupMapWithoutDefault = {};
                citiesWithoutDefault.forEach((rule) => {
                    const groupKey = `${rule.guaranteePeriod || 'empty'}_${rule.guaranteePeriodType || 'empty'}`;
                    if (!groupMapWithoutDefault[groupKey]) {
                        groupMapWithoutDefault[groupKey] = {
                            guaranteePeriod: rule.guaranteePeriod,
                            guaranteePeriodType: rule.guaranteePeriodType,
                            cityIds: [],
                        };
                    }
                    groupMapWithoutDefault[groupKey].cityIds.push(rule.manageCityId);
                });

                autoGroups.push(...this.convertGroupsToFinalFormat(groupMapWithoutDefault));
            }

            // 赋值给保质期
            this.$emit('update-guarantee-period', autoGroups);
        },
    },
};
</script>

<style scoped lang="scss">
.existed-ids-disabled {
    position: relative;
    &::after {
       content: '';
       top: 0;
       right: 0;
       bottom: 0;
       left: 0;
       position: absolute;
       z-index: 2;
       cursor: not-allowed;
   }
}
.description{
    color: #95989E;
    margin-left: 130px;
    font-size: 12px;
}
.prompt-day{
    font-size: 18px;
    color: red;
    font-weight: 700;
}
::v-deep .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #EB2F3C !important;
}
</style>
